import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/Blockchain box with people.avif';
import trustImage from '../pictures/Small Trust.it.webp';
import chainImage from '../pictures/Back-Step Blockchain data flow.avif';

export function What_is_BSB() {
  return (
    <MarketingArticle
      title="Back-Step Blockchain"
      kicker="Trusted records"
      description="A patented blockchain architecture for organizations that need fast, permanent, and affordable proof without the burden of large mining networks."
      path="/overview"
      heroImage={heroImage}
      heroAlt="People carrying a blockchain box"
      primaryAction={{ to: '/products', label: 'View products' }}
      secondaryAction={{ to: '/contact', label: 'Discuss a use case' }}
      sections={[
        {
          tag: 'What changes',
          title: 'Reliable proof becomes practical for everyday business.',
          image: chainImage,
          imageAlt: 'Back-Step Blockchain data flow',
          paragraphs: [
            'Back-Step Blockchain is designed for high-volume records: product certificates, signed events, business documents, payments, AI prompts, and security logs.',
            'Instead of asking customers to understand blockchain mechanics, it gives them a simple promise: important data can be stored, verified, and trusted later.',
          ],
          items: [
            'Permanent records with variable payload sizes.',
            'Fast operation for real customer workflows.',
            'Hardware-supported security for stronger protection.',
          ],
        },
        {
          tag: 'First experience',
          title: 'Trust.it shows what the platform can do.',
          image: trustImage,
          imageAlt: 'Trust.it application concept',
          paragraphs: [
            'Trust.it is our public service for trying Back-Step Blockchain in a simple application. Users can store text, files, proofs, and public messages without owning cryptocurrency.',
            'It is a practical demonstration for partners who want to build their own products on the same foundation.',
          ],
        },
      ]}
    />
  );
}
